var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow31(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2243 16H37.7337C38.4884 16 39.2212 16.1203 39.9321 16.3719C40.9602 16.7438 41.8899 17.4 42.5899 18.2531C43.3009 19.1063 43.7712 20.1562 43.9352 21.25C44.0009 21.6547 44.0118 22.0594 44.0118 22.4641V37.5906C44.0118 38.0719 43.9899 38.5641 43.8915 39.0344C43.6727 40.1172 43.1587 41.1344 42.4149 41.9547C41.6821 42.775 40.7196 43.3875 39.6805 43.7156C39.0462 43.9125 38.3899 44 37.7227 44C37.4274 44 22.1805 44 21.9509 43.9891C20.8352 43.9344 19.7305 43.5734 18.8009 42.95C17.893 42.3375 17.1493 41.4844 16.668 40.5C16.2524 39.6578 16.0446 38.7172 16.0446 37.7766V22.2234C16.0227 21.2938 16.2196 20.375 16.6243 19.5438C17.0946 18.5594 17.8274 17.6953 18.7352 17.0828C19.6649 16.4484 20.7587 16.0766 21.8743 16.0219C21.9837 16 22.104 16 22.2243 16Z",
    fill: "url(#paint0_linear_2335_35483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.625 38.9031C39.5266 38.75 39.4172 38.5969 39.2969 38.4547C39.0234 38.1266 38.7063 37.8422 38.3563 37.6016C37.9188 37.3062 37.4047 37.1203 36.8797 37.0984C36.5078 37.0766 36.1359 37.1422 35.7859 37.2734C35.4359 37.3937 35.0969 37.5688 34.7688 37.7437C34.3859 37.9406 34.0031 38.1375 33.5984 38.3016C33.1172 38.4984 32.6141 38.6516 32.1 38.7609C31.4547 38.8813 30.7984 38.925 30.1531 38.9141C28.9828 38.8922 27.8125 38.7172 26.6969 38.3891C25.7125 38.0938 24.7719 37.6891 23.8859 37.175C23.1094 36.7266 22.3875 36.2125 21.7094 35.6328C21.1516 35.1516 20.6375 34.6375 20.1563 34.0906C19.8281 33.7078 19.5109 33.3031 19.2156 32.8875C19.0953 32.7234 18.9859 32.5484 18.8875 32.3734L16 29.2562V22.2016C16 18.7781 18.7672 16 22.1906 16H27.7141L31.8047 20.1562C41.0359 26.4344 38.05 33.3578 38.05 33.3578C38.05 33.3578 40.675 36.3109 39.625 38.9031Z",
    fill: "url(#paint1_linear_2335_35483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8258 20.1562C41.057 26.4344 38.0711 33.3578 38.0711 33.3578C38.0711 33.3578 40.6961 36.3219 39.6352 38.9141C39.6352 38.9141 38.5523 37.0984 36.7367 37.0984C34.9867 37.0984 33.9586 38.9141 30.4367 38.9141C22.5945 38.9141 18.8867 32.3625 18.8867 32.3625C25.9523 37.0109 30.7758 33.7188 30.7758 33.7188C27.593 31.8703 20.8227 23.0328 20.8227 23.0328C26.718 28.0531 29.2664 29.3766 29.2664 29.3766C27.7461 28.1188 23.4805 21.9719 23.4805 21.9719C26.893 25.4281 33.6742 30.2516 33.6742 30.2516C35.5992 24.9141 31.8258 20.1562 31.8258 20.1562Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2335_35483",
    x1: 32.6577,
    y1: 15.0009,
    x2: 27.3675,
    y2: 45.0025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2335_35483",
    x1: 30.2857,
    y1: 16.4524,
    x2: 26.4139,
    y2: 38.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow31);
export default __webpack_public_path__ + "static/media/row-3-1.1e995560e61993009d046cb31fc26119.svg";
export { ForwardRef as ReactComponent };